import { createFileRoute, Outlet } from '@tanstack/react-router';

import Layout from '@/screens/chat/projects/id/layout';

export const Route = createFileRoute('/_app/_chat/projects/$projectId')({
  component: LayoutRoute,
});

function LayoutRoute() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}
